import { Link } from "react-router-dom";
import SearchBar from "../SearchBar";
import {
  deleteStampcard,
  getBusinesses,
  getStampcards,
} from "../../actions/acc_actions";
import { useQuery } from "@tanstack/react-query";
import Loading from "../../utils/Loading";
import FlipCard from "../FlipCard";
import { Button, Form, Input, message, Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useState } from "react";
import ContentLayout from "../layout/ContentLayout";
import { CiCirclePlus } from "react-icons/ci";

export default function Stampcard({ accUrn, businessUrn }) {
  const {
    isLoading: stampLoading,
    refetch,
    data: stampcardsData,
  } = useQuery({
    queryKey: ["stampcards", accUrn],
    queryFn: () => getStampcards(businessUrn, accUrn),
    enabled: !!accUrn && !!businessUrn,
  });

  const { isLoading: businessLoading, data: businessesData } = useQuery({
    queryKey: ["userBusinesses", accUrn],
    queryFn: () => getBusinesses(accUrn),
    enabled: !!accUrn,
  });

  const isLoading = businessLoading || stampLoading;

  const business = businessesData?.data?.at(-1);

  // State for delete modal and reason input
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteReason, setDeleteReason] = useState("");
  const [cardToDelete, setCardToDelete] = useState(null);

  // Show modal and set card urn to delete
  const showDeleteModal = (cardUrn) => {
    setCardToDelete(cardUrn);
    setDeleteReason("");
    setDeleteModalVisible(true);
  };

  // Confirm deletion with reason
  const handleDeleteConfirm = () => {
    if (!deleteReason.trim()) {
      message.error("Please provide a reason for deletion.");
      return;
    }

    deleteStampcard({
      loyalty_scheme_urn: cardToDelete,
      account_urn: accUrn,
      reason: deleteReason,
    })
      .then(() => {
        refetch();
        message.success(
          "The deletion Request is now pending for confrimation.",
        );
        refetch();
        setDeleteModalVisible(false);
        setCardToDelete(null);
      })
      .catch(() => {
        message.error("Something went wrong!!");
      });
  };

  // Cancel deletion modal
  const handleDeleteCancel = () => {
    setDeleteModalVisible(false);
    setCardToDelete(null);
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <ContentLayout
      header={
        !isLoading ? (
          <h1>
            Welcome to <br /> <span>Stamp Card Dashboard</span>
          </h1>
        ) : (
          <div className="screen-notification">
            <img src="/assets/images/bg/shop.png" alt="" />
            <h2 className="active">Start Your Online Shop</h2>
            <h5>
              Don't miss out on boosting your sales and customer loyalty!
              Purchase gift cards through our app now.
            </h5>
            <Link className="btn primary" to="add">
              Add Your First Voucher
            </Link>
          </div>
        )
      }
    >
      {!isLoading && (
        <div className="outlet-cards">
          <Link to="create" className="outlet-add btn">
            <CiCirclePlus size={48} />
            <div className="outlet-add-content">
              <p>Add New</p>
              <h4 className="active">Stamp Card</h4>
            </div>
          </Link>

          <div className="cards-container">
            {stampcardsData?.data?.map((item, index) => {
              const isPortal = item.rules?.by_portal;

              return (
                <div
                  className={`stampcard-conatiner ${
                    item.hasDeletionRequest ? "pending-deletion" : ""
                  }`}
                  key={index}
                >
                  {isPortal ? (
                    // Normal FlipCard
                    <FlipCard
                      className="flipcard"
                      business={business}
                      item={item}
                    />
                  ) : (
                    // Static gray card
                    <div
                      style={{ background: "#e9e9e9ff", position: "relative" }}
                      className="card-container"
                    >
                      <h3
                        style={{
                          position: "absolute",
                          top: "40%",
                          left: "10%",
                          width: "80%",
                          textAlign: "center",
                        }}
                        className="card-title"
                      >
                        {item.name || "Unnamed"}
                      </h3>
                    </div>
                  )}

                  <Button
                    type="primary"
                    className="delete-btn"
                    icon={<DeleteOutlined />}
                    onClick={() => showDeleteModal(item.urn)}
                    danger
                    disabled={item.hasDeletionRequest}
                  >
                    Delete
                  </Button>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Delete Reason Modal */}
      <Modal
        title="Reason for Deleting the Card"
        visible={deleteModalVisible}
        onOk={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        okText="Delete"
        okButtonProps={{ danger: true }}
      >
        <Form layout="vertical">
          <Form.Item
            label="Please provide a reason"
            required
            validateStatus={deleteReason.trim() ? "success" : "error"}
            help={!deleteReason.trim() ? "Reason is required." : ""}
          >
            <Input.TextArea
              rows={4}
              value={deleteReason}
              onChange={(e) => setDeleteReason(e.target.value)}
              placeholder="Type your reason for deletion here..."
            />
          </Form.Item>
        </Form>
      </Modal>
    </ContentLayout>
  );
}
